import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";
import CreatableSelect from "react-select/creatable";

const CustomOption = (props) => {
    const { isDisabled, data } = props;

    return !isDisabled ? (
        <components.Option {...props} className={"searchable-dropdown__custom_options"}>
            {data.label}
            {data.temp === "Y" && <sup>Temp</sup>}
        </components.Option>
    ) : null;
};

const CustomSingleValue = (props) => {
    return (
        <components.SingleValue {...props}>
            {props.children}
            {props.data.temp === "Y" && <sup>Temp</sup>}
        </components.SingleValue>
    );
};

const SearchableSelect = ({
    options,
    onChange,
    value,
    name = "",
    search = false,
    textAlign = null,
    placeholderTextAlign = "right",
    arrow = false,
    isTable = false,
    isTable2 = false,
    placeholder = "▼",
    isDisabled = false,
    border = null,
    height = null,
    revision = false,
    textWrap = false,
    createable = false,
    isClearable = false,
    boldborder = false,
    menuPlacement="bottom"
}) => {
    const customStyle = {
        option: (provided, state) => ({
            ...provided,
            paddingLeft: "4px",
            textAlign: textAlign,
            width: "100%",
            color: state.isDisabled ? "#CCC" : "#000",
            backgroundColor: state.isFocused ? "#EEEEFF" : "#FFF",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: "#555",
            textAlign: textAlign,
            fontSize: isTable ? "12px" : isTable2 ? "16px" : "inherit",
            whiteSpace: textWrap ? "initial" : null,
        }),
        menu: (provided, state) => ({
            ...provided,
            width: "max-content",
            minWidth: "100%",
            fontSize: isTable2 ? "16px" : null,
            zIndex: 20,
            backgroundColor: "#FFF",
        }),
        control: (provided, state) => ({
            ...provided,
            border: border ? null : "none",
            borderColor: boldborder ? null : "#AAA" ,
            backgroundColor: "transparent",
            boxShadow: "none",
            minHeight: "initial",
            height: height,
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            padding: "0",
        }),
        placeholder: (provided, state) => ({
            ...provided,
            textAlign: placeholderTextAlign,
            paddingRight: "5px",
            color: state.isDisabled ? "transparent" : "#CCC",
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            display: arrow ? null : "none",
            padding: "6px",
        }),
        indicatorSeparator: (provided, state) => ({
            ...provided,
            display: "none",
        }),
    };

    const [_value, _setValue] = useState(null);

    const setVal = () => {
        let locVal;

        if (value === null || value === undefined || value === "") {
            locVal = null;
        } else {
            locVal = options?.find((e) => e.value?.toString().toUpperCase() === value?.toString().toUpperCase());

            if (locVal === null) {
                locVal = { label: value, value: value };
            }
        }
        _setValue(locVal);
    };

    useEffect(() => {
        setVal();
    }, [value, options]);

    if (createable) {
        return <CreatableSelect
            className={"searchable-dropdown createable"}
            classNamePrefix={"searchable-dropdown"}
            styles={customStyle}
            value={_value}
            onChange={onChange}
            isSearchable={true}
            options={options}
            name={name}
            isDisabled={isDisabled}
            placeholder={placeholder}
            menuPlacement={menuPlacement}
            isClearable={isClearable}
            components={revision ? { SingleValue: CustomSingleValue, Option: CustomOption } : null}
        />;
    } else {
        return (
            <Select
                className={"searchable-dropdown"}
                classNamePrefix={"searchable-dropdown"}
                styles={customStyle}
                value={_value}
                onChange={onChange}
                isSearchable={search}
                options={options}
                name={name}
                isDisabled={isDisabled}
                isClearable={isClearable}
                placeholder={placeholder}
                menuPlacement={menuPlacement}
                components={revision ? { SingleValue: CustomSingleValue, Option: CustomOption } : null}
            />
        );
    }
};

export default SearchableSelect;
